import { rangefilterByRange, rangefilterBySector, rangefilterBySupergroup } from '../Constants/TableConfiguration'
import { filterDistinctByProperty } from './GenericHelpers'

const hasRanges = commissions => {
  //if theres only one element with threshold range is set. So retrieve ranges and other value. Other value object is same as general object
  return commissions.filter(x => !x.sectorId && !x.supergroupId && x.threshold && x.threshold > 0).length > 0
}

const retrieveCommission = commissions => {
  return commissions.find(x => !x.threshold && !x.sectorId && !x.supergroupId)
}

const hasSectors = commissions => {
  return commissions.find(x => x.sectorId && !x.supergroupId)
}

const hasSupergroups = commissions => {
  return commissions.find(x => x.supergroupId)
}

const hasSupergroupsSectors = commissions => {
  return commissions.find(x => x.sectorId && x.supergroupId)
}

const retrieveCommissions = (channelList, id) => {
  const currentChannel = channelList.find(x => x.name === id)
  return currentChannel && currentChannel.commissions ? currentChannel.commissions : []
}

const retrieveRangeThresholds = commissions => {
  return commissions
    .filter(x => !x.sectorId && !x.supergroupId && x.threshold && x.threshold > 0)
    .filter((value, index, self) => filterDistinctByProperty(value, index, self, 'threshold'))
    .sort((a, b) => {
      return a.threshold - b.threshold
    })
}

const retrieveSectorValue = (commissions, sectorId, threshold) => {
  const currentSector =
    threshold || threshold === 0
      ? commissions.find(x => x.sectorId === sectorId && x.threshold === threshold && !x.supergroupId)
      : commissions.find(x => x.sectorId === sectorId && !x.threshold && !x.supergroupId)
  const sectorValue = currentSector ? currentSector.value : null
  return sectorValue
}

const retrieveSectorSupergroupValue = (commissions, supergroupId, sectorId, threshold) => {
  const currentSupergroupSector =
    threshold || threshold === 0
      ? commissions.find(x => x.supergroupId === supergroupId && x.sectorId === sectorId && x.threshold === threshold)
      : commissions.find(x => x.supergroupId === supergroupId && x.sectorId === sectorId && !x.threshold)
  const supergroupValue = currentSupergroupSector ? currentSupergroupSector.value : null
  return supergroupValue
}

const retrieveSupergroupValue = (commissions, supergroupId, threshold) => {
  const currentSupergroup =
    threshold || threshold === 0
      ? commissions.find(x => x.supergroupId === supergroupId && x.threshold === threshold && !x.sectorId)
      : commissions.find(x => x.supergroupId === supergroupId && !x.threshold && !x.sectorId)
  const supergroupValue = currentSupergroup ? currentSupergroup.value : null
  return supergroupValue
}

const isTableCommissionsRangeFilterSet = tableCommissions => {
  return tableCommissions.indexOf(rangefilterByRange) !== -1
}

const isTableCommissionsSectorFilterSet = tableCommissions => {
  return tableCommissions.indexOf(rangefilterBySector) !== -1
}

const isTableCommissionsSupergroupFilterSet = tableCommissions => {
  return tableCommissions.indexOf(rangefilterBySupergroup) !== -1
}

export {
  hasRanges,
  hasSectors,
  hasSupergroups,
  retrieveCommission,
  retrieveCommissions,
  retrieveRangeThresholds,
  retrieveSectorValue,
  retrieveSupergroupValue,
  hasSupergroupsSectors,
  retrieveSectorSupergroupValue,
  isTableCommissionsRangeFilterSet,
  isTableCommissionsSectorFilterSet,
  isTableCommissionsSupergroupFilterSet,
}
